import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postFertilization,
  putFertilization,
  deleteFertilization,
  postHarvest,
  putHarvest,
  deleteHarvest,
  postPesticideApplication,
  putPesticideApplication,
  deletePesticideApplication,
  postSeeding,
  putSeeding,
  deleteSeeding,
  postSoilPreparation,
  putSoilPreparation,
  deleteSoilPreparation
} from '@galo-monitor/services/apis/galoMonitorApi/resources/activity'

import ActivityConstants from './activityConstants'
import { ActivityActions, ActivityTypes } from './duckActivity'

function* saveActivity({ activity, onSuccess = () => {}, onError = () => {} }) {
  try {
    const { type } = activity
    switch(type) {
      case ActivityConstants.FERTILIZATION_ACTIVITY_TYPE:
        yield call(activity.id ? putFertilization : postFertilization, activity)
        break
      case ActivityConstants.HARVEST_ACTIVITY_TYPE:
        yield call(activity.id ? putHarvest : postHarvest, activity)
        break
      case ActivityConstants.PESTICIDE_APPLICATION_ACTIVITY_TYPE:
        yield call(activity.id ? putPesticideApplication : postPesticideApplication, activity)
        break
      case ActivityConstants.SEEDING_ACTIVITY_TYPE:
        yield call(activity.id ? putSeeding : postSeeding , activity)
        break
      case ActivityConstants.SOIL_PREPARATION_ACTIVITY_TYPE:
        yield call(activity.id ? putSoilPreparation : postSoilPreparation , activity)
        break
      default:
        throw new Error('invalid activity type')
    }
    yield call(onSuccess)
  } catch (err) {
    yield put(ActivityActions.activityError(err.message))
    yield call(onError, err)
  }
}

function* removeActivity({ activity, onSuccess = () => {}, onError = () => {} }) {
  try {
    const { type } = activity
    switch(type) {
      case ActivityConstants.FERTILIZATION_ACTIVITY_TYPE:
        yield call(deleteFertilization, activity)
        break
      case ActivityConstants.HARVEST_ACTIVITY_TYPE:
        yield call(deleteHarvest, activity)
        break
      case ActivityConstants.PESTICIDE_APPLICATION_ACTIVITY_TYPE:
        yield call(deletePesticideApplication, activity)
        break
      case ActivityConstants.SEEDING_ACTIVITY_TYPE:
        yield call(deleteSeeding, activity)
        break
      case ActivityConstants.SOIL_PREPARATION_ACTIVITY_TYPE:
        yield call(deleteSoilPreparation, activity)
        break
      default:
        throw new Error('invalid activity type')
    }
    yield call(onSuccess)
  } catch (err) {
    yield put(ActivityActions.activityError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(ActivityTypes.SAVE_ACTIVITY, saveActivity),
  takeLatest(ActivityTypes.REMOVE_ACTIVITY, removeActivity)
]
